// ── PoP Registry ──────────────────────────────────────────────────────────────
// Single source of truth for PoP IDs → display names.
// Used by both the buyer portal (location picker) and the seller dashboard
// (auction detail display). Must stay in sync with the on-chain registerPoP()
// calls in deploy_filterslot.py.

export interface Location {
  id: number
  city: string
  country: string
}

export const locations: Location[] = [
    // { id: 5128581, city: "New York", country:"US" },
    { id: 4140963, city: "Ashburn", country:"US" },
    { id: 5368361, city: "Los Angeles", country:"US" },
    { id: 4164138, city: "Miami", country:"US" },
    // { id: 5809844, city: "Seattle", country:"US" },
    // { id: 4699066, city: "Dallas", country:"US" },
    // { id: 4887398, city: "Chicago", country:"US" },
    // { id: 6077243, city: "Montreal", country:"CA" },
    // { id: 6167865, city: "Toronto", country:"CA" },
    { id: 2643743, city: "London", country:"GB" },
    { id: 2759794, city: "Amsterdam", country:"NL" },
    // { id: 2950159, city: "Berlin", country:"DE" },
    { id: 2925533, city: "Frankfurt am Main", country:"DE" },
    // { id: 2988507, city: "Paris", country:"FR" },
    // { id: 3117735, city: "Madrid", country:"ES" },
    // { id: 3169070, city: "Rome", country:"IT" },
    // { id: 2761369, city: "Vienna", country:"AT" },
    // { id: 2618425, city: "Copenhagen", country:"DK" },
    // { id: 3143244, city: "Oslo", country:"NO" },
    // { id: 2673730, city: "Stockholm", country:"SE" },
    // { id: 292223, city: "Dubai", country:"AE" },
    // { id: 6691831, city: "Tel Aviv", country:"IL" },
    // { id: 281184, city: "Jerusalem", country:"IL" },
    // { id: 360630, city: "Cairo", country:"EG" },
    // { id: 993800, city: "Johannesburg", country:"ZA" },
    // { id: 1006984, city: "Cape Town", country:"ZA" },
    // { id: 2352778, city: "Lagos", country:"NG" },
    // { id: 160263, city: "Nairobi", country:"KE" },
    { id: 1819729, city: "Hong Kong", country:"HK" },
    // { id: 1850147, city: "Tokyo", country:"JP" },
    // { id: 1861060, city: "Osaka", country:"JP" },
    // { id: 1835848, city: "Seoul", country:"KR" },
    // { id: 1816670, city: "Beijing", country:"CN" },
    // { id: 1796236, city: "Shanghai", country:"CN" },
    // { id: 1275339, city: "Mumbai", country:"IN" },
    // { id: 1261481, city: "Delhi", country:"IN" },
    { id: 1880252, city: "Singapore", country:"SG" },
    // { id: 1609350, city: "Bangkok", country:"TH" },
    // { id: 1735161, city: "Kuala Lumpur", country:"MY" },
    // { id: 2147714, city: "Sydney", country:"AU" },
    // { id: 2158177, city: "Melbourne", country:"AU" },
    { id: 1668341, city: "Taipei", country:"TW" },
    { id: 3621849, city: "San José", country:"CR" },
    { id: 3448439, city: "São Paulo", country:"BR" },
    { id: 3067696, city: "Prague", country:"CZ" },
    { id: 3060972, city: "Bratislava", country:"SK" },
]

/** Returns the display label for a PoP ID, falling back to "PoP {id}" if unknown. */
export function popLabel(id: number): string {
  const pop = locations.find(p => p.id === id)
  if(!pop) {
    return `${id}`
  }

  return `${pop.city}, ${pop.country}`
}
